import { LoadingButton } from "@mui/lab";
import { Button, Grid, Stack, TextField } from "@mui/material";
import { CommonModal } from "components/molecules";
import { isEmpty } from "lodash";
import { useState } from "react";
import { PrintActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";

const UpdateStatusModal = (props: {
  open: boolean;
  onConfirm(note: string): void;
  onClose(): void;
}) => {
  const { open, onClose, onConfirm } = props;
  const [note, setNote] = useState<string>("");

  const handelConfirm = () => {
    onConfirm(note);
  };

  const renderFooter = () => {
    return (
      <Footer
        disableConfirm={isEmpty(note)}
        onClose={onClose}
        onConfirm={handelConfirm}
      />
    );
  };

  return (
    <CommonModal
      title="Xác nhận đóng gói lại"
      open={open}
      FooterComponent={renderFooter()}
      handleClose={onClose}
    >
      <Grid
        sx={{ width: "100%" }}
        container
        xs={12}
        alignItems="center"
        rowGap={2}
      >
        <Grid xs={12} item>
          <TextField
            value={note}
            onChange={(event) => setNote(event.target.value)}
            label={"Lí do"}
            fullWidth
          />
        </Grid>
      </Grid>
    </CommonModal>
  );
};

const Footer = (props: {
  disableConfirm: boolean;
  onConfirm(): void;
  onClose(): void;
}) => {
  const { disableConfirm, onConfirm, onClose } = props;
  const action = useAppSelector((state) => state.PrintReducer.action);
  return (
    <Stack direction={"row"} spacing={2} justifyContent={"flex-end"}>
      <Button onClick={onClose}>Huỷ</Button>
      <LoadingButton
        loading={action.includes(PrintActions.print.requestName)}
        disabled={disableConfirm}
        onClick={onConfirm}
        variant="contained"
      >
        Xác nhận
      </LoadingButton>
    </Stack>
  );
};
export default UpdateStatusModal;
